<!-- svelte-ignore a11y-missing-attribute -->
<nav class="navbar x-is-spaced" role="navigation" aria-label="main navigation">
  <div class="navbar-brand">
    <a class="navbar-item" href="/">
      <img src="/assets/img/logo_h.png" height="38" />
    </a>

    <a
      on:click={() => (isMobileMenuActive = !isMobileMenuActive)}
      role="button"
      class="navbar-burger"
      aria-label="menu"
      aria-expanded="false"
      data-target="navbarBasicExample"
    >
      <span aria-hidden="true" />
      <span aria-hidden="true" />
      <span aria-hidden="true" />
    </a>
  </div>

  <div
    id="navbarBasicExample"
    class="navbar-menu"
    class:is-active={isMobileMenuActive}
  >
    <div class="navbar-start">
      <a
        class="navbar-item is-tab"
        class:is-active={$isActive('./index')}
        href={$url('./index')}
      >
        Home
      </a>

      {#if $appState.user?.isFullAdmin || $appState.user?.isDelegatedAdmin} 
      <a
        class="navbar-item is-tab"
        class:is-active={$isActive('./offers')}
        href={$url('./offers')}
      >
        Offers
      </a>
      {/if}

      {#if $appState.user?.isFullAdmin || $appState.user?.isFullCharityAdmin}
      <a
        class="navbar-item is-tab"
        class:is-active={$isActive('./needs')}
        href={$url('./needs')}
      >
        Needs
      </a>
      {/if}

      {#if $appState.user?.isFullAdmin || $appState.user?.isDelegatedAdmin} 
      <a
        class="navbar-item is-tab"
        class:is-active={$isActive('./business')}
        href={$url('./business')}
      >
        Businesses
      </a>
      {/if}

      <a
        class="navbar-item is-tab"
        class:is-active={$isActive('./charity')}
        href={$url('./charity')}
      >
        Charities
      </a>

      <a
        class="navbar-item is-tab"
        class:is-active={$isActive('./user')}
        href={$url('./user')}
      >
        Users
      </a>

      {#if $appState.user?.isFullAdmin} 
      <div class="navbar-item has-dropdown is-hoverable">
        <a class="navbar-link"> Settings </a>

        <div class="navbar-dropdown">
          <a
            class="navbar-item is-tab"
            class:is-active={$isActive('./settings/general')}
            href={$url('./settings/general')}
          >
            General
          </a>

          <a
            class="navbar-item is-tab"
            class:is-active={$isActive('./settings/tags')}
            href={$url('./settings/tags')}
          >
            Tags
          </a>

          <a
            class="navbar-item is-tab"
            class:is-active={$isActive('./settings/email_templates')}
            href={$url('./settings/email_templates')}
          >
            Email templates
          </a>

          <a
            class="navbar-item is-tab"
            class:is-active={$isActive('./settings/operations')}
            href={$url('./settings/operations')}
          >
            Operations
          </a>
        </div>
      </div>
      {/if}

    </div>

    <div class="navbar-end">
      <div class="navbar-item">
        <div class="buttons">
          <a on:click={logoff}>
            {#if $appState.user}
              <img
                src="https://ui-avatars.com/api/?name={$appState.user?.firstName}+{$appState.user?.lastName}&rounded=true"
                height="38"
              />
            {/if}
          </a>
        </div>
      </div>
    </div>
  </div>
</nav>

<script lang="ts">
  import { isActive, url, goto, beforeUrlChange } from '@sveltech/routify';
  import { appState } from '../../../lib/appState';

  let isMobileMenuActive = false;

  // close menu on navigation
  $beforeUrlChange(() => {
    isMobileMenuActive = false;
    return true;
  });

  async function logoff() {
    let firebase = window.firebase;
    await firebase.auth().signOut();

    $goto('../..');
  }
</script>

<style>
  .navbar {
    padding: 0rem 1rem;
    border-bottom: 1px solid #eee;
  }

  .navbar-item img {
    max-height: 2.2rem !important;
  }

  .navbar-item.is-tab {
    font-weight: 500;
  }
</style>
